export const loadBussinessesMutation = (state, businesses) => {
    state.businesses = businesses;
};

export const duplicateBussinessMutation = (state, business) => {
    state.businesses.push(business);
};
